module.exports = __webpack_public_path__ + "img/all.da035b5f.svg";